// Temporary icon replacements using react-icons
// This will be replaced with @heroicons/react once installed

import {
  HiFilter,
  HiViewGrid,
  HiBookmark,
  HiStar,
  HiDotsVertical,
  HiChevronDown,
  HiChevronRight,
  HiX,
  HiAdjustments,
  HiSearch,
  HiBell,
  HiCheck,
  HiTrash,
  HiRefresh,
  HiCog,
  HiPlus,
  HiInformationCircle,
  HiChartBar,
  HiClock,
  HiExclamation,
  HiCheckCircle,
  HiMenu,
  HiPencil,
  HiDuplicate,
  HiEye,
  HiLockClosed,
  HiChevronLeft,
  HiArrowDown,
  HiArrowUp,
  HiExclamationCircle,
  HiSortAscending,
  HiSortDescending,
  HiCalendar,
  HiDownload,
  HiShare,
  HiCode,
  HiTemplate,
  HiViewList,
  HiUserGroup,
  HiTag,
  HiArchive,
  HiReply,
  HiHome,
  HiSparkles,
  HiPause,
  HiPlay,
  HiClipboard,
  HiMinusCircle,
  HiSave,
  HiCollection,
  HiColorSwatch,
  HiUsers,
  HiWifi,
  HiTicket,
  HiServer,
  HiXCircle,
  HiBadgeCheck,
  HiMinus,
  HiUser,
  HiChat,
  HiChevronUp,
  HiEyeOff,
  HiChartPie
} from 'react-icons/hi';

// Map heroicon names to react-icons
export const FunnelIcon = HiFilter;
export const Squares2X2Icon = HiViewGrid;
export const BookmarkIcon = HiBookmark;
export const StarIcon = HiStar;
export const EllipsisVerticalIcon = HiDotsVertical;
export const ChevronDownIcon = HiChevronDown;
export const ChevronRightIcon = HiChevronRight;
export const XMarkIcon = HiX;
export const AdjustmentsHorizontalIcon = HiAdjustments;
export const MagnifyingGlassIcon = HiSearch;
export const BellIcon = HiBell;
export const CheckIcon = HiCheck;
export const TrashIcon = HiTrash;
export const ArrowPathIcon = HiRefresh;
export const CogIcon = HiCog;
export const Cog6ToothIcon = HiCog;
export const PlusIcon = HiPlus;
export const InformationCircleIcon = HiInformationCircle;
export const ChartBarIcon = HiChartBar;
export const ClockIcon = HiClock;
export const ExclamationTriangleIcon = HiExclamation;
export const CheckCircleIcon = HiCheckCircle;
export const Bars3Icon = HiMenu;
export const FilterIcon = HiFilter;

export const PencilIcon = HiPencil;
export const DocumentDuplicateIcon = HiDuplicate;
export const EyeIcon = HiEye;
export const LockClosedIcon = HiLockClosed;
export const ChevronLeftIcon = HiChevronLeft;
export const ArrowDownIcon = HiArrowDown;
export const ArrowUpIcon = HiArrowUp;
export const ExclamationCircleIcon = HiExclamationCircle;
export const ArrowsUpDownIcon = HiSortAscending; // Generic sort icon
export const CalendarIcon = HiCalendar;
export const ArrowDownTrayIcon = HiDownload;
export const ShareIcon = HiShare;
export const CodeBracketIcon = HiCode;
export const DocumentTextIcon = HiTemplate;
export const ListBulletIcon = HiViewList;
export const UserGroupIcon = HiUserGroup;
export const TagIcon = HiTag;
export const ArchiveBoxIcon = HiArchive;
export const ArrowUturnLeftIcon = HiReply;
export const HomeIcon = HiHome;
export const SparklesIcon = HiSparkles;
export const PauseIcon = HiPause;
export const PlayIcon = HiPlay;
export const ClipboardIcon = HiClipboard;
export const MinusCircleIcon = HiMinusCircle;
export const DocumentIcon = HiSave;
export const RectangleStackIcon = HiCollection;
export const SwatchIcon = HiColorSwatch;
export const UsersIcon = HiUsers;
export const WifiIcon = HiWifi;
export const TicketIcon = HiTicket;
export const ServerIcon = HiServer;
export const XCircleIcon = HiXCircle;
export const SignalIcon = HiWifi; // Using WiFi as signal icon
export const MinusIcon = HiMinus;
export const UserIcon = HiUser;
export const ChatBubbleLeftRightIcon = HiChat;
export const ChevronUpIcon = HiChevronUp;
export const EyeSlashIcon = HiEyeOff;
export const SignalSlashIcon = HiEyeOff; // Using EyeOff as signal slash
export const ChartPieIcon = HiChartPie;

// Solid icons (using same icons for now)
export { HiBell as BellSolidIcon };
export { HiStar as StarSolidIcon };
export { HiBookmark as BookmarkSolidIcon };

// Export all for easy use
export * from 'react-icons/hi';